import { InjectionToken } from '@angular/core';
import { HTTPMethod } from '../enums/http-methods.enum';
import { InterceptorEndpoints } from '../models/interceptor-endpoints.model';

export const CACHE_BREAKER_SDVOR_ENDPOINTS: InterceptorEndpoints[] = [{ url: '/orders', methods: [HTTPMethod.GET] }];

export const CACHE_BREAKER_ENDPOINTS = new InjectionToken<InterceptorEndpoints[]>('cachebreakersEndpoints');
